import '@adyen/adyen-web/styles/adyen.css';
// polyfill setimmediate for SSR
// https://docs.expo.io/guides/using-nextjs/#polyfill-setimmediate
import 'setimmediate';
import App, { AppContext, AppProps } from 'next/app';
import Head from 'next/head';
import { getEffectiveLanguage } from '@/utils/i18n';
import { setWasmUrl } from '@lottiefiles/dotlottie-react';
import { useEffect } from 'react';

// self-host dotlottie WASM to avoid CDN rate limiting
// see: https://github.com/LottieFiles/dotlottie-web/issues/423
setWasmUrl('/dotlottie-player.wasm');

function WebApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    document.documentElement.lang = getEffectiveLanguage();
  }, []);

  return (
    <>
      <Head>
        <meta
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          name="viewport"
        />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

WebApp.getInitialProps = async (appContext: AppContext) => {
  return await App.getInitialProps(appContext);
};

export default WebApp;
